import { createSelector, createFeatureSelector } from '@ngrx/store';
import { IAppState } from '../../state/app.state';
import { ITransactionActionType } from 'src/app/models/transactions';
import { createEntityAdapter } from '@ngrx/entity';
import { ITransactionTypesState } from '../../state/transaction-type.state';

export const getTransactionTypesState = createFeatureSelector<IAppState, ITransactionTypesState>('transactionTypes');

export const transactionTypeAdapter = createEntityAdapter<ITransactionActionType>({
    selectId: (transactionType: ITransactionActionType) => transactionType.code
});

export const selectTransactionTypes = createSelector(
    getTransactionTypesState,
    (state) => {
        return state;
    }
);

export const getCashSelectedTransactionType = createSelector(
    getTransactionTypesState,
    (state) => {
        return state.selectedCashType;
    }
)

export const getRevenueSelectedTransactionType = createSelector(
    getTransactionTypesState,
    (state) => {
        return state.selectedRevenueType;
    }
)

export const getSecuritySelectedTransactionType = createSelector(
    getTransactionTypesState,
    (state) => {
        return state.selectedSecurityType;
    }
)